var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Messages',{staticClass:"in-page-messages",attrs:{"messages":_vm.messages},on:{"dismiss":_vm.dismiss}})
}
var staticRenderFns = []

export { render, staticRenderFns }